var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.123 1.37695V2.75391H11.0615H0V4.13086V5.50781H1.37695H2.75391V18.084V30.6602H1.37695H0V32.0371V33.4141H23.5H47V32.0371V30.6602H45.623H44.2461V18.084V5.50781H45.623H47V4.13086V2.75391H35.9385H24.877V1.37695V0H23.5H22.123V1.37695ZM38.7383 14.4121V18.8184H37.3613H35.9844V16.7762V14.7339L30.3133 20.4045L24.642 26.0752L21.8909 21.4425L19.1396 16.8098L14.6646 21.279L10.1896 25.7481L9.2031 24.7617L8.21665 23.7751L13.9073 18.0839C17.0372 14.9536 19.6204 12.3926 19.6476 12.3926C19.6748 12.3926 20.8935 14.4011 22.3558 16.856C23.8182 19.3109 25.056 21.3767 25.1064 21.4468C25.1778 21.5456 26.1812 20.5909 29.6041 17.1669L34.01 12.7598H31.9679H29.9258V11.3828V10.0059H34.332H38.7383V14.4121ZM22.123 40.207V44.2461H18.2217H14.3203V45.623V47H23.5H32.6797V45.623V44.2461H28.7783H24.877V40.207V36.168H23.5H22.123V40.207Z",
    fill: "#7DA4B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.38c65024f2dd72a631dca9945fe205aa.svg";
export { ForwardRef as ReactComponent };